"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const a=require("./index53.js");var e=a.global,l=e;exports.path=l;
